// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Contact_wrapper__1wcnv","title":"Contact_title__3tDON","hero-text":"Contact_hero-text__rhzzq","input-form":"Contact_input-form__3IJP0"};